import Shepherd from 'shepherd.js';
import { injectStepUI, markTourStartDate } from './TourHelpers';
import type { ShepherdTour, TrackableTour } from './TourHelpers';

export function createSubAssemblyDiagramTour(): ShepherdTour {
  const tour = new Shepherd.Tour({
    useModalOverlay: true,
    defaultStepOptions: {
      classes: 'shepherd-theme-custom',
      scrollTo: true,
      cancelIcon: {
        enabled: true
      },
      modalOverlayOpeningPadding: 6,
      modalOverlayOpeningRadius: 6
    }
  });
  (tour as TrackableTour).__tourStartDate = null;

  tour.addStep({
    id: "step1",
    text: '<strong class="tour-step-header">When an assembly/sub-assembly option is available, you will see the assembly listed first.</strong><br>The sub-assembly items will be featured in a list directly below the assembly. This list can also be collapsed or expanded by clicking the down arrow.',
    attachTo: {
      element: '.diagram-results-panel__assembly-section',
      on: "left"
    },
    canClickTarget: false,
    scrollTo: false,
    when: {
      show() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        injectStepUI(this.getElement(), 1, 2);
      }
    },
    buttons: [
      {
        text: "Next",
        action: () => {
          markTourStartDate(tour);
          tour.next();
        }
      }
    ]
  });

  tour.addStep({
    id: "step2",
    text: '<strong class="tour-step-header">Additional pages to view the sub-assembly breakdown will be featured as an option to click through.</strong><br>Clicking the arrow to navigate to the next page or by clicking a part in the sub-assembly list will bring you to the sub-assembly breakdown.',
    attachTo: {
      element: '.diagram-results-panel__diagram-switcher',
      on: "bottom"
    },
    canClickTarget: false,
    when: {
      show() {
        injectStepUI(this.getElement(), 2, 2);
      }
    },
    scrollTo: false,
    buttons: [
      {
        text: "Close",
        action: () => {
          tour.complete();
        }
      }
    ]
  });

  return tour;
}